import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Box,
  Menu,
  MenuItem,
  Typography,
  Tooltip,
} from "@mui/material";

import "./auditconfig.scss";
import Label from "../../../components/Label/Label";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useState } from "react";

export default function ParameterTable({ data, moreOption, handleMenuOption }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [selectedRow, setSelectedRow] = useState();

  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const parseValue = (value) => {
    if (!value) return null;
    if (typeof value === "object") return value;
    if (typeof value === "string") {
      try {
        const formatted = value.replace(/'/g, '"');
        return JSON.parse(formatted);
      } catch {
        return null;
      }
    }
    return null;
  };

  const renderHoverIcon = (value) => {
    const parsed = parseValue(value);
    if (!parsed) return "-";

    const entries = Object.entries(parsed);

    return (
      <Tooltip
        title={
          <Box display="flex" flexDirection="column" gap={0.5} maxWidth={300}>
            {entries.map(([key, val]) => (
              <Box key={key} display="flex" justifyContent="space-between">
                <Typography fontWeight={600}>{key}</Typography>
                <Typography sx={{ ml: 1, textAlign: "right" }}>
                  {String(val)}
                </Typography>
              </Box>
            ))}
          </Box>
        }
        arrow
        placement="top-start"
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: "#f5f5f5", // light gray
              color: "#333", // dark text
              fontSize: 13,
              boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
            },
          },
        }}
      >
        <IconButton size="small">
          <InfoOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    );
  };

  return (
    <Box width="100%">
      <TableContainer
        component={Paper}
        className="audit-conf-table-container"
        sx={{ scrollbarGutter: "auto" }}
      >
        <Table stickyHeader sx={{ tableLayout: "fixed", width: "100%" }}>
          <TableHead className="table-header">
            <TableRow>
              <TableCell className="audit-table-header-cell">Sr No.</TableCell>
              <TableCell className="audit-table-header-cell">
                Event Name
              </TableCell>
              <TableCell className="audit-table-header-cell">
                Previous Value
              </TableCell>
              <TableCell className="audit-table-header-cell">
                Updated Value
              </TableCell>
              <TableCell className="audit-table-header-cell">
                Updated By
              </TableCell>
              <TableCell className="audit-table-header-cell">
                Last Updated
              </TableCell>
              {/* <TableCell className="audit-table-header-cell" align="right">Action</TableCell> */}
            </TableRow>
          </TableHead>

          <TableBody
            sx={{
              "& .MuiTableRow-root": { height: 48 },
              "& .MuiTableCell-root": { py: 0.5 },
            }}
          >
            {data?.data?.results?.map((row, index) => (
              <TableRow key={index}>
                <TableCell>
                  {data?.data?.page_size * (data?.data?.page - 1) + index + 1}
                </TableCell>
                <TableCell sx={{ fontSize: 14 }}>{row.event_name}</TableCell>
                <TableCell>
                  {row.previous_value
                    ? renderHoverIcon(row.previous_value)
                    : " "}
                </TableCell>
                <TableCell>
                  {row.updated_value ? renderHoverIcon(row.updated_value) : " "}
                </TableCell>
                <TableCell sx={{ fontSize: 14 }}>{row.updated_by}</TableCell>
                <TableCell sx={{ fontSize: 14 }}>{row.updated_at}</TableCell>
                {/* <TableCell align="right">
                  <IconButton size="small" onClick={(e) => handleClick(e, row)}>
                    <MoreVertIcon />
                  </IconButton>
                </TableCell> */}
              </TableRow>
            ))}

            {!data?.loader && data?.data?.results?.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <Label color="textSecondary" text="No data found" />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
          {moreOption?.map((option) => (
            <MenuItem
              key={option}
              onClick={() => {
                handleMenuOption(option, selectedRow);
                handleClose();
              }}
            >
              {option}
            </MenuItem>
          ))}
        </Menu>
      </TableContainer>
    </Box>
  );
}
